import DemandReg from './DemandRegContent'
import DemandContextProvider from '../../context/demand-context'

function DemandContextWrapper(props) {
    return (
        <DemandContextProvider>
            <DemandReg/>
        </DemandContextProvider>
    )
}

export default DemandContextWrapper 